import { render } from "./addDrugPair.vue?vue&type=template&id=0c8f7044&scoped=true"
import script from "./addDrugPair.vue?vue&type=script&lang=js"
export * from "./addDrugPair.vue?vue&type=script&lang=js"

import "./addDrugPair.vue?vue&type=style&index=0&id=0c8f7044&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8f7044"]])

export default __exports__